import { Injectable, inject } from '@angular/core';
import { retry } from 'rxjs/operators';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { AppUrls } from './route/app-urls';
import { RBCheck } from '@ldw/roesberg';

@Injectable({ providedIn: 'root' })
export class AppConfig {
  private httpBackend = inject(HttpBackend);

  public CONFIG: any;
  public isLoading = true;
  private httpClient: HttpClient;

  // version of Android App, has to be provided
  public appVersion = '';

  public fatalError = '';

  public hasError(): boolean {
    return !RBCheck.isNullOrEmpty(this.fatalError);
  }

  constructor() {
    const httpBackend = this.httpBackend;
    // use HttpBackend to bypass Tokeninjector and prevent circular dendency
    this.httpClient = new HttpClient(httpBackend);
  }

  public loadConfig(): Promise<any> {
    /*const promise = this.http.get(this.configUrl)
        .retry(3)
        .map(response => response.json())
        .toPromise();

    promise.then(data => {
        this.CONFIG = data;
    });
    return promise; */

    const promise = this.httpClient.get(AppUrls.getApiUrl(AppUrls.urlSettings, 'getSystem')).pipe(retry(3)).toPromise();

    promise.then((data) => {
      this.CONFIG = data;
    });
    return promise;

    /*
    const prom = new Promise((resolve, reject) => {
        this.httpClient.get(this.configUrl)
        .pipe(retry(3))
        .subscribe(data => {
                this.CONFIG = data;
            })
    })

    return prom;
    */

    /*
   let ob = this.httpClient.get(this.configUrl).pipe(retry(3))
    .subscribe( data => {
        this.CONFIG = data;
    });
    return of(ob).toPromise();

*/

    /*

            const res = this.httpClient.get(this.configUrl).pipe(retry(3));
            const promise = toPromise(res);

            promise.then(data => {
                this.CONFIG = data;
            });
            return promise;
            */
  }

  public externalIdentity(): boolean {
    return this.CONFIG.useExternalIdentity;
  }

  public extIdentityShowLogin(): boolean {
    return this.CONFIG.externalIdentityShowLogin;
  }


  public extIdentityUri(): string {
    return this.CONFIG.externalIdentityUri;
  }

  public extIdentityClientId(): string {
    return this.CONFIG.externalIdentityClientID;
  }


  public hasPrivacyLink(): boolean {
    return !RBCheck.isNullOrEmpty(this.CONFIG.privacyUrl);
  }

  public urlPrivacy(): string {
    return this.CONFIG.privacyUrl;
  }

  public textPrivacy(): string {
    return this.CONFIG.privacyText;
  }

  public hasImprintLink(): boolean {
    return !RBCheck.isNullOrEmpty(this.CONFIG.imprintUrl);
  }

  public urlImprint(): string {
    return this.CONFIG.imprintUrl;
  }

  public textImprint(): string {
    return this.CONFIG.imprintText;
  }

  public hasServerInfo(): boolean {
    return !RBCheck.isNullOrEmpty(this.CONFIG.serverInfo);
  }

  public serverInfo(): string {
    return this.CONFIG.serverInfo;
  }

  public extIdentityScopes(): string {
    return this.CONFIG.externalIdentityScopes;
  }

  public defaultLanguage(): string {
    return this.CONFIG.defaultLanguage;
  }




  public jwks() {
    return this.CONFIG.jwksPublic;
  }

  public disableSSL(): boolean {
    return this.CONFIG.disableSSL;
  }

  public disableFdfSave(): boolean {
    return this.CONFIG.disableFDFSave;
  }
  public editorLicence(): string {
    return this.CONFIG.editorLicence;
  }
  public isMobileApp() : boolean {
    return !RBCheck.isNullOrEmpty(this.appVersion);
  }

  public isLocked(): boolean {
    return this.CONFIG.isLocked;
  }
  public messageHeader(): string {
    return this.CONFIG.messageHeader;
  }
  public messageText(): string {
    return this.CONFIG.messageText;
  }

  public version(): string {
    let version = '24.99.99';
    if (this.CONFIG != null && this.CONFIG.version != null) {
      version = this.CONFIG.version;
    }
    if (this.isMobileApp()) {
      version = version + ' ' + this.appVersion;
    }
    return version;
  }
}
